module.exports = {
  isHeadwayTail: 'Конечный ход',
  containerLoadType: 'Тип доверенности',
  transportType: 'Вид перевозки',
  fullHalf: 'Весь путь / полпути',
  transportLine: 'Маршрут',
  ETD: 'Дата отгрузки',
  ETA: 'Дата прибытия',
  ATD: 'Фактическая дата отгрузки',
  ETD2: 'Дата отгрузки (ETD)',
  ETA2: 'Дата прибытия (ETA)',
  ATD2: 'Фактическая дата отгрузки (ATD)',
  ATA2: 'Фактическая дата прибытия (ATA)',
  departureStation: 'исходящая станция',
  departureStationRe: 'Станция отправления (железная дорога)',
  transferStation: 'Транспортная станция',
  transitStation: 'Пункт пересечения границы',
  destinationStation: 'Станция назначения',
  destinationStationRe: 'Станция назначения (железная дорога)',
  destinationCountry: 'Страна назначения',
  portAgent: 'Агент порта',
  forwardingAgent: 'экспедитор',
  paymentMethod: 'Способы оплаты',
  mbl: 'Номер накладной',
  vessel: 'Автобус',
  voyageFlight: 'Поездки',
  isDiffPlacesCollaborate: 'Координация в разных местах',
  loadingPlaceCompany: 'Компания & quot; Место погрузки & quot;',
  signBillPlaceCompany: 'Компании по месту подписания',
  isFullShipment: 'Весь путь',
  dischargePortCompany: 'Порт разгрузки',
  destinationPortCompany: 'Порт назначения',
  overseaOp: 'Обслуживание иностранных клиентов',
  planner: 'Руководитель маршрута',
  plannerOffice: 'Маршрутная компания',
  plannerDepartment: 'Маршруты',
  batchVessel: 'Массовая пересадка',
  Query: 'Запрос',
  BuyContainer: 'Купить ящик',
  CallContainer: 'Перемещение контейнера',
  SellContainer: 'Продать ящик',
  RentContainer: 'Арендный ящик',
  ClearContainerLog: 'Очистить историю перемещений',
  ReturnBox: 'Возврат контейнера',
  Edit: 'Редактирование',
  Delete: 'Удалить',
  OrderNo: 'Номер заказа',
  OrderNo2: 'Номер заказа',
  JobNo2: 'Бизнес-номер',
  ConsignationCompany: 'Клиент-заказчик',
  BoxOwner: 'Владелец контейнера/продавец',
  BoxOwner3: 'Владелец контейнера',
  BoxOwner2: 'Продавец',
  Buyer2: 'Покупатель',
  Buyer: 'Покупатель',
  OrderType: 'Тип заказа',
  ContainerStatus: 'Состояние ящика',
  ContainerType: 'Тип контейнера',
  Amount: 'Сумма',
  WhetherSettlement: 'Расчеты',
  SettlingTime: 'Дата расчёта',
  BuyerTime: 'Дата покупки',
  SellTime: 'Дата продажи',
  ReturnTime: 'Дата возвращения',
  OperationTime: 'Дата операции',
  Prompt1: 'Введите номер заказа',
  Prompt2: 'Введите номер контейнера',
  QuantitySum: 'Общее количество контейнеров',
  AmountSum: 'Общая сумма',
  Quantity2: 'Количество',
  BuyTime: 'Дата покупки',
  SellerDate: 'Дата продажи',
  RentDate: 'Дата начала аренды',
  StartRentDate: 'Дата начала аренды',
  ReturnDate: 'Дата окончания',
  UnitRate: 'Цена за единицу',
  ContainerNo: 'Номер контейнера',
  CurrencyCode: 'Валюта',
  EQSize: 'Тип контейнера',
  EQType: 'Вид контейнера',
  EQQuantity: 'Количество контейнеров',
  Add: 'Добавить',
  Confirm: 'Подтвердить',
  Cancel: 'Отмена',
  Operation: 'Действие',
  UnitRate2: 'Цена за единицу (RMB/день)',
  UnitRate3: 'RMB/день',
  ReturnBoxDate: 'Время возврата контейнера',
  Term: 'Срок',
  Day: 'День',
  UnitPriceInterval: 'Диапазон цен',
  BuyBoxTotalTankVolume: 'Общее количество купленных контейнеров',
  TotalCost: 'Общая сумма затрат',
  SellOutTotalTankVolume: 'Общее количество проданных контейнеров',
  TotalSalesAmount: 'Общая сумма продаж',
  CostUnitPrice: 'Себестоимость единицы',
  CostUnitPriceCurrencyCode: 'Валюта себестоимости единицы',
  SellingUnitPrice: 'Цена продажи единицы',
  SellingUnitPriceCurrencyCode: 'Валюта цены продажи единицы',
  ETDNotNull: 'Дата отправки не может быть пустой',
  ETANotNull: 'Дата прибытия не может быть пустой',
  PaymentMethodCannotBlank: 'Способ оплаты не может быть пустым',
  DepartureStationCannotEmpty: 'Станция отправления не может быть пустой',
  TransferStationCannotEmpty: 'Промежуточная станция не может быть пустой',
  TransitStationCannotEmpty: 'Транзитная станция не может быть пустой',
  DestinationStationCannotEmpty: 'Станция назначения не может быть пустой',
  CharacterLengthTooLongMaintainAgain: 'Превышена длина символов, пожалуйста, исправьте!',
  TheNotOnTheBustrain: 'Выбранные документы не относятся к одному и тому же автобусу/рейсу',
  OperationFailed: 'Ошибка операции',
  SelectTime: 'Выберите время',
  BulkModifyDestinationPortInformation: 'Массовое изменение информации о порте назначения',
  NonWarehouseOverseasTransferWarehouse: 'Зарубежный транзитный склад (не склад Amazon)',
  EstimatedDeliveryTime: 'Предполагаемое время доставки',
  ActualDeliveryTime: 'Фактическое время доставки',
  DomesticWarehouse: 'Внутренний склад',
  OverseasWarehouse: 'Зарубежный склад',
  WithCostRefundForClearing: '(Возврат с уплатой пошлины)',
  TheExpiresAndNoCreated: 'Договор с данной доверенной организацией истёк, создание новых операций невозможно',
  DueNotBePrintedNeeded: 'Из-за превышения кредитного лимита данная накладная заблокирована, печать и EDI недоступны. Для разблокировки обратитесь к руководству!',
  LockedPleaseContactTheUnlock: 'Заблокировано, печать невозможна. Обратитесь к руководителю для разблокировки!',
  FCLProfitPrint: 'Печать прибыли по контейнеру',
  AttachmentContentTooLarge: 'Содержимое вложения слишком большое',
  LCLProfitPrint: 'Печать прибыли по сборному грузу',
  ContainerType2: 'Тип контейнера',
  AdjustmentOperation: 'Операция перемещения контейнеров',
  All: 'Все',
  Days: 'День',
  ExpectedToEnterAmazonWarehouse: 'Ожидаемое время поступления на склад Amazon',
  ReferenceContainerNumber: 'Референсный номер контейнера',
  Export: 'Экспорт',
  Import: 'Импорт',
  ReturnContainer: 'Возврат контейнера',
  PleaseEnterContainerInformation: 'Введите информацию о контейнере!',
  PleaseEnterReturnContainerTime: 'Введите время возврата контейнера!',
  ReturnSuccessfulSuccessfulReturnCount: 'Возврат контейнера успешен! Количество успешных возвратов:',
  NumberOfContainerPieces: 'Количество мест в контейнере:',
  GreaterActualNumberOfPieces: 'Превышает фактическое количество:',
  ContainerWeight: 'Вес контейнера:',
  GreaterThanTheActualWeight: 'Превышает фактический вес:',
  ContainerVolume: 'Объём контейнера:',
  GreaterThanTheActualVolume: 'Превышает фактический объём:',
  JobNumber: 'Рабочий номер:',
  ServiceChannel: 'Сервисный канал',
  PostalCode: 'Почтовый индекс',
  DestinationDeliveryMethod: 'Способ доставки в пункт назначения',
  ExpressCompany: 'Курьерская компания',
  TrackingNumber: 'Трек-номер',
  POoriginalOrderNumber: 'PO (оригинальный номер)',
  CustomsDeclarationMethod: 'Способ таможенного оформления',
  CustomsClearanceMethod: 'Способ таможенной очистки',
  EORIEnterpriseNumber: 'EORI номер предприятия',
  VATtaxNumber: 'НДС/ИНН',
  VATRegistrationCountry: 'Страна регистрации НДС',
  VATRegistrationAddress: 'Адрес регистрации НДС',
  VATCompanyEnglishName: 'Английское название компании для НДС',
  WithBattery: 'С бат.',
  WithMagnet: 'Магн.',
  Powder: 'Пор.',
  Liquid: 'Жидк.',
  EstimatedStoragegoodsReadyTime: 'Планируемое время поступления на склад/готовности груза',
  RemoteWarehouse: 'Удаленный склад',
  ThisHasExpiredCannotBusiness: 'Договор с данной доверенной организацией истек, создание новых операций невозможно',
  Freight: 'Стоимость перевозки',
  ServiceChannel2: 'Канал обслуживания:',
  CostType: 'Тип расходов:',
  EstimatedAmount: 'Ориентировочная сумма:',
  EquivalentTo: 'Эквивалент',
  FareLevel: 'Уровень тарифа:',
  BillingWeight: 'Расчетный вес:',
  CalculationMethod: 'Способ расчета:',
  TheTypeCannotBeEmpty: 'Тип поручения не может быть пустым',
  TransportTypeCannotBeEmpty: 'Тип перевозки не может быть пустым',
  FullJourneyCannotBeEmpty: 'Полный/частичный маршрут не может быть пустым',
  ShippingRouteCannotBeEmpty: 'Маршрут не может быть пустым',
  DepartureBeLaterThanDate: 'Дата отправки не может быть позже даты прибытия',
  DepartureStationCannotBeEmpty: 'Станция отправления не может быть пустой',
  TransitStationCannotBeEmpty: 'Станция пересадки не может быть пустой',
  TransitStationCannotBeEmpty2: 'Транзитная станция не может быть пустой',
  DestinationStationCannotBeEmpty: 'Станция назначения не может быть пустой',
  PaymentMethodCannotBeEmpty: 'Способ оплаты не может быть пустым',
  SalesCannotBeEmpty: 'Продажа не может быть пустой',
  OperationCannotBeEmpty: 'Операция не может быть пустой',
  AlreadyOtherBoxTypesTime: 'Уже выбраны [полувагон/крытый вагон/платформа], нельзя одновременно выбирать другие типы контейнеров!',
  EstimatedTimeCannotBeEmpty: 'Планируемое время поступления на склад/готовности груза не может быть пустым!',
  DestinationCannotBeEmpty: 'Пункт назначения не может быть пустым!',
  DestinationCountryCannotBeEmpty: 'Страна назначения не может быть пустой!',
  ZipCodeCannotBeEmpty: 'Почтовый индекс не может быть пустым!',
  CannotBeEmpty: 'Не может быть пустым!',
  PleaseTheEntrustingUnitFirst: 'Пожалуйста, сначала выберите доверенную организацию.',
  EstimatedStoragegoodReadyTime: 'Планируемое время поступления на склад/готовности груза',
  NoTicketChecked: 'Чек не отмечен',
  CustomersOwnContainer: 'Контейнер клиента',
  CompanyOwnedContainer: 'Собственный контейнер компании',
  RentalContainer: 'Арендованный контейнер',
  ContainerUsageImportTemplateRailwayXls: 'Шаблон импорта использования контейнеров (железная дорога).xls',
  CurrentBeenSubmittedCannotOperate: 'Текущая операция уже отправлена, нельзя выполнить действие!',
  AreWantToPerformOperation: 'Вы уверены, что хотите выполнить это действие?',
  CostNotConfiguredPleaseCheck: 'Тип расходов не настроен, пожалуйста, проверьте!',
  CostAuditedOrInvoicedCheck: 'Расходы уже проверены или выставлен счет, пожалуйста, проверьте!',
  CleaningCompletedSuccessfulCleaningNumber: 'Очистка завершена! Успешно очищено количество:',
  PleaseBoxesYouWantProcess: 'Пожалуйста, отметьте контейнеры, которые нужно обработать!',
  ContainsContainerDataPleaseCheck: 'Содержит данные о не перемещенных контейнерах, пожалуйста, проверьте!',
  PleaseSelectAContainer: 'Пожалуйста, выберите один контейнер',
  FirstLeglastLeg: 'Первая/последняя миля',
  TransportationMethod: 'Способ транспортировки',
  ContactPerson: 'Контактное лицо',
  DetailedAddress: 'Подробный адрес',
  FirstLeglastLegInformation: 'Информация о первой/последней миле',
  CustomerDoordestinationPortDoor: 'Клиентский пункт/пункт назначения в порту',
  CustomerContactPerson: 'Контактное лицо клиента',
  FirstLegCannotBeEmpty: 'Поле "Первая/последняя миля" не может быть пустым',
  PleaseEnterTransportationCompanyInformation: 'Введите информацию о транспортной компании',
  PleaseSelectDesignatedData: 'Выберите указанные данные',
  PleaseSelectTradeInformation: 'Выберите торговую информацию.',
  RailwayOperationGoodsDetails: 'Детали железнодорожных операций с грузом',
  SellingContainer: 'Продажа контейнеров',
  TotalPurchaseContainer: 'Общее количество купленных контейнеров',
  TotalCostAmount: 'Общая сумма затрат',
  TotalSoldContainer: 'Общее количество проданных контейнеров',
  TotalSellingAmount: 'Общая сумма продаж',
  ModificationSuccessful: 'Изменения успешно сохранены',
  BuyingContainer: 'Покупка контейнеров',
  Yes: 'Да',
  No: 'Нет',
  PleaseTheContainerToEdit: 'Выберите контейнер для редактирования!',
  EditOrderInformation: 'Редактирование информации о заказе',
  PleaseTheContainerToDelete: 'Выберите контейнер для удаления!',
  AreWantToDeleteInformation: 'Подтвердите удаление информации о контейнере?',
  PromptInformation: 'Информационное сообщение',
  DeletingOrderContainsOccupiedContainers: 'В заказе содержатся занятые контейнеры!',
  CurrentlySelected: '(Текущий выбор)',
  CurrentPage: '(Текущая страница)',
  CurrentlyAvailable: 'Доступно сейчас',
  CurrentlyOccupied: 'Занято сейчас',
  Sold: 'Продано',
  ContainerInquiry: 'Поиск контейнеров',
  BoxReturnedCannotContinueOperate: 'Контейнер с номером: {0} уже возвращен, операция невозможна!'
}

